<mat-drawer-container class="sidenav-container">
    <mat-drawer #drawer class="sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

        <!-- Header: Logo pegado arriba -->
        <div class="sidebar-header p-3 d-flex align-center">
            <img ngSrc="/lo128.png" priority width="32" height="32" class="me-2">
            <h2 class="magistral text-lg m-0">NT LINK</h2>
        </div>

        <!-- Navegación: Pegada arriba -->
        <mat-nav-list class="flex-grow-1 px-2">
            @for (item of routes; track $index) {
            <a mat-list-item [routerLink]="item.link" #link="routerLinkActive" routerLinkActive
                [activated]="link.isActive" class="rounded mb-1">
                <mat-icon matListItemIcon class="material-symbols-outlined">{{item.data?.['icon']}}</mat-icon>
                <span matListItemTitle class="text-xs fw-medium">{{item.title}}</span>
            </a>
            }
        </mat-nav-list>

        <!-- Footer: Estilos abajo -->
        <div class="sidebar-footer p-3 d-flex justify-center gap-2 border-top-thin">
            <app-climate-toggle></app-climate-toggle>
            <app-palette-picker></app-palette-picker>
        </div>

    </mat-drawer>

    <mat-drawer-content #drawerContent>
        <mat-toolbar class="d-flex align-center px-3" [class.mat-elevation-z2]="false">

            <!-- Toggle Sidebar -->
            <button mat-icon-button (click)="drawer.toggle()" class="me-2 sidebar-toggle-btn">
                <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
            </button>

            <!-- Breadcrumbs -->
            <div class="d-flex align-center h-full">
                <a routerLink="/" class="d-flex align-center">
                    <mat-icon class="icon-sm">home</mat-icon>
                </a>

                @for (crumb of breadcrumbs$ | async; track $index; let last = $last) {
                <mat-icon class="mx-1 icon-sm d-inline-flex align-center">chevron_right</mat-icon>

                @if (last) {
                <span>{{ crumb.label | titlecase }}</span>
                } @else {
                <a [routerLink]="crumb.url">
                    {{ crumb.label | titlecase }}
                </a>
                }
                }
            </div>

            <span class="flex-spacer"></span>

            <div class="d-flex align-center gap-3">
                <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu" class="rounded-pill px-3">
                    <mat-icon class="material-symbols-outlined me-2 icon-sm">account_circle</mat-icon>
                    {{username}}
                    <mat-icon class="ms-2 icon-sm opacity-50">expand_more</mat-icon>
                </button>
                <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item [routerLink]="['/portal/profile']">
                        <mat-icon class="material-symbols-outlined">person</mat-icon>
                        <span>Mi Perfil</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="logout()">
                        <mat-icon class="material-symbols-outlined">logout</mat-icon>
                        <span>Cerrar Sesión</span>
                    </button>
                </mat-menu>
            </div>
        </mat-toolbar>

        <div class="sidenav-scroll-wrapper">
            <div class="sidenav-content p-4">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>